import React, { useState, useEffect } from 'react';
import Papa from "papaparse";
import '../assets/css/RelatedTour.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

const RelatedTour = () => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const sheetURL =
      "https://docs.google.com/spreadsheets/d/e/2PACX-1vQJB4XDn4cM60lvPxxVwBp8--5AHiSti_X9DNNSbnH_L1SnzodWZRsBM2E8wFUKbdIzsdBQMga5x-Dr/pub?output=csv";

    Papa.parse(sheetURL, {
      download: true,
      header: true,
      complete: function (results) {
        const rows = results.data;

        // ⭐ REMOVE EMPTY OR INVALID ROWS
        const cleanRows = rows.filter(
          (row) =>
            row.id &&
            row["tourDetails.tourName"] &&
            row["tourDetails.thumbnail"] &&
            row["tourDetails.startDate"]
        );

        const parsedTours = cleanRows.map(row => ({
          id: Number(row.id),

          tourDetails: {
            tourName: row["tourDetails.tourName"],
            displayName: row["tourDetails.displayName"],

            dates: {
              startDate: row["tourDetails.startDate"],
              endDate: row["tourDetails.endDate"]
            },

            thumbnail: row["tourDetails.thumbnail"],
            image: row["tourDetails.image"],

            // ⭐ SAFE PRICE OBJ
            price: {
              amount: Number(row["tourDetails.price.amount"]) || 0
            },

            // ⭐ SAFE RATING (DEFAULT = 5)
            rating: Number(row["tourDetails.rating"]) || 5,
          }
        }));

        // Sort newest → oldest  
        const sortedTours = parsedTours.sort((a, b) => b.id - a.id);

        // Select first 4 valid tours  
        const limitedData = sortedTours.slice(0, 4);

        // Sort 4 tours by start date  
        limitedData.sort(
          (a, b) =>
            new Date(a.tourDetails.dates.startDate) -
            new Date(b.tourDetails.dates.startDate)
        );

        setData(limitedData);
      }
    });
  }, []);

  const detail = (id) => {
    navigate('/detail', { state: { id } });
  };

  return (
    <div className="RelatedTour container">
      <h4 className="Title">Related Tours</h4>
      <div className="TourImages">
        <div className="row">

          {data.map((tour, index) => (
            <div key={index} className="col-lg-3 col-sm-12 col-md-4">
              <div className="img-container" onClick={() => detail(tour.id)}>

                <img
                  src={tour.tourDetails.thumbnail}
                  alt={`Image ${index + 1}`}
                  className="image"
                />

                <div className="overlay">
                  <div className="text1">Explore</div>
                  <div className="ExploreImg">
                    <img className="Explore" src="images/Cardlable.svg" alt="Explore Label" />
                  </div>
                </div>

                <p className="ImageTitle">{tour.tourDetails.tourName}</p>

                <div className="rating">

                  {[...Array(tour.tourDetails.rating)].map((_, i) => (
                    <FontAwesomeIcon
                      key={i}
                      icon={faStar}
                      className="star"
                      style={{ color: '#386B33' }}
                    />
                  ))}

                  {[...Array(5 - tour.tourDetails.rating)].map((_, i) => (
                    <FontAwesomeIcon
                      key={tour.tourDetails.rating + i}
                      icon={faStar}
                      className="star"
                      style={{ color: '#DDD' }}
                    />
                  ))}

                </div>
              </div>
            </div>
          ))}

        </div>
      </div>
    </div>
  );
};

export default RelatedTour;
